import React, { useState, useEffect, useRef } from "react";
import "../../../../../../../css/workspace.css";
import {
  getWalkthroughs,
  uploadTextV2
} from "../../../../../../../redux/actions/collectionsV2";
import { connect, useSelector, useDispatch} from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import {
  Button,
  Input,
} from "antd";
import { notify } from "../../../../../../../components/Snack";
import * as types from "../../../../../../../redux/constants/collectionConstants";

const AddText = () => {

    const [isLoading, setIsLoading] = useState(false);
    const [docsList, setDocsList] = useState([]);
    const [docListTemp, setDocListTemp] = useState([]);
    const [globalResourceName, setGlobalResourceName] = useState("");
    const [globalTextValue, setGlobalTextValue] = useState("");

    const { TextArea } = Input;

    const dispatch = useDispatch();
    const queryParams = useLocation().search;

    const collectionName =  new URLSearchParams(queryParams).get("name");

    const documentsList = useSelector(
      (state) => state.collectionReducer.collectionDocs
    );
    
    const uniqueDocuments = (arr) => {
      const seen = new Map();
  
      arr.forEach((doc) => {
        const { document_name, status } = doc;
        // If the document name is not in the map, add it
        if (!seen.has(document_name)) {
          seen.set(document_name, doc);
        } else {
          // If it exists, check the status
          if (status === "success") {
            // If the new doc has status success, replace the existing one
            seen.set(document_name, doc);
          }
        }
      });
      // Convert the map back to an array
      return Array.from(seen.values());
    };

    useEffect(() => {
      setDocsList(documentsList);
    }, [documentsList]);

    useEffect(() => {
      if (docsList?.length > 0) {
        const result = uniqueDocuments(docsList);
        dispatch({
          type: types.UPDATE_COLLECTION_DOCS_LIST,
          collectionDocs: result,
        });
      }
    }, [docsList]);

    const groupPlan = useSelector((state) => state.userReducer.groupPlan);
    let planType;
    if (groupPlan?.planId == 4) {
        planType = "team";
    } else if (groupPlan?.planId == 5) {
        planType = "business";
    } else {
        planType = "pro";
    }

  
    const uploadText = async () => {
      if (globalResourceName.length < 1) {
        dispatch(notify("error", "Please enter a valid Resource name"));
        return;
      }
      if(globalResourceName.length >= 64){
        dispatch(notify("error", "Resource name must be less than 64 characters"));
        return;
      }
    
      let fileType = "text";
      let userType = groupPlan?.planId === 4 ? "team" : groupPlan?.planId === 5 ? "business" : "pro";
    
      let uploadTextResponse;
      setDocsList((prevArray) => [
        ...prevArray,
        {
          document_name: globalResourceName,
          status: "in-progress",
          text_data: null,
        },
      ]); 
      setIsLoading(true);
    
      try {
        uploadTextResponse = await uploadTextV2(
          collectionName,
          fileType,
          globalTextValue,
          globalResourceName,
          userType
        );
      } catch (error) {
        console.error("Upload failed:", error);
        setIsLoading(false);
        dispatch(notify("error", "Something went wrong during upload"));
        return;
      }
    
      setIsLoading(false);
    
      if (uploadTextResponse?.data?.status === "OK") {
        setDocsList((prevArray) => [
          ...prevArray,
          {
            document_name: globalResourceName,
            status: "success",
            text_data: null,
          },
        ]); 
        setGlobalResourceName("");
        setGlobalTextValue("");
        dispatch(notify("success", "Text uploaded successfully."));
      } else {
        setDocsList((prevArray) => [
          ...prevArray,
          {
            document_name: globalResourceName,
            status: "failed",
            text_data: null,
          },
        ]); 
        dispatch(notify("error", "Something went wrong"));
        setGlobalResourceName("");
        setGlobalTextValue("");
      }
    };

    return (
        <>
        <div className="text-block" style={{marginTop : "20px", }}>
              <div className="img-selector">
              <div className="up-flex-items doc-url">
                <div className="input-clear">
                      <h6>Resource name</h6>
                <Input
                  type="text"
                  size="small"
                  placeholder="Enter Resource name"
                  value={globalResourceName}
                  onChange={(e) => setGlobalResourceName(e.target.value)}
                />
                </div>
              </div>
              
                <div className="up-flex-items doc-url textarea-wk">
                  
                  <div className="input-clear">
                  <h6>Enter your text</h6>
                <TextArea
                  rows={4}
                  size="small"
                  placeholder="Enter your text here"
                  value={globalTextValue}
                  onChange={(e) => setGlobalTextValue(e.target.value)}
                />
                  </div>
                </div>

                <div className="btn-flex-1 text-center">
                  {isLoading ? (
                    <button className="btn btn-primary">
                      <div class="sp sp-circle text-light"></div>
                    </button>
                  ) : (
                    <Button
                      type="primary"
                      size="small"
                      onClick={() => uploadText()}
                    >
                      Submit
                    </Button>
                  )}
                </div>
              </div>
        </div>
        </>
    )

}
export default AddText;